import { createSignal, onMount } from "solid-js";

const [urlParams, setUrlParams] = createSignal({});

const getUrlParams = () => {
  const params = new URLSearchParams(window.location.search);
  const paramObject = {};
  params.forEach((value, key) => {
    paramObject[key] = value;
  });
  return paramObject;
};

onMount(() => {
  setUrlParams(getUrlParams());
});

export { urlParams };
